import { Link, styled } from "@material-ui/core";

const SecondaryLink = styled(Link)({
  fontWeight: 400,
  color: "inherit",
  textDecoration: "none",
});

export default SecondaryLink;
